import axios from 'axios'
import qs from 'qs'
import store from '../store'
import {getHostData} from './getHostData';
import utils from '@/tools/commonUtil'
// axios 配置

const Axios = axios.create({
  baseURL: getHostData().VUE_APP_APIHOST,
  timeout: getHostData().VUE_APP_APITIMEOUT,
})

// POST传参序列化
Axios.interceptors.request.use((config) => {
  const is_login = store.getters["user/isLogin"]
  if (config.method === 'get') {
    config.data = function (params) {
      return qs.stringify(params, { arrayFormat: "repeat" })
    }
  }
  if (is_login) {
    const token = store.getters["user/userBase"].token
    config.headers.Authorization = 'Token ' + token;
  }
  return config
}, (error) => {
  return Promise.reject(error)
})
// 返回状态判断
Axios.interceptors.response.use(config => {
  if (config.method === 'get'||config.method==='GET') {
    config.url = encodeURI(config.url)
  }
  if(config.data.code == 40){
    store.dispatch('page/response-error-msg', config.data);
    return Promise.reject(config);
  }else if(config.data.code == 51){
    store.dispatch('page/response-error-msg', config.data);
    return Promise.reject(config);
  }
  return config
}, error => {
  if (error.response && error.response.status == 401) {
    localStorage.removeItem('authenticated')
    window.location.reload()
  }
  if (error.response && error.response.status == 500) {
    store.dispatch('page/response-error', error.response)
  }
  return Promise.reject(error.response,'error')
})

export default Axios

